import { Container, GridWrapper } from '@sainsburys-tech/luna-grid'
import { useNavigate, useLocation } from 'react-router-dom';
import { Key, useEffect } from 'react'
import useCurrentStore from '../../hooks/useCurrentStore'
import Loading from '../Loading'
import { Card } from '@sainsburys-tech/luna-card'
import ErrorMessage from '../ErrorMessage'
import { Pagination } from '@sainsburys-tech/luna-pagination'
import { IPagination } from '../../types/Pagination/IPagination'
import useGuardingActivities from '../../hooks/useGuardingActivities'
import { IGuardingActivityDetails } from '../../types/GuardingActivity/IGuardingActivityType';
import GuardingActivityCard from '../Card/Cards/GuardingActivityCard';

const GuardingDailyActivities = () => {
  const navigate = useNavigate()
  const storeCode = useCurrentStore().storeCode
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const currentPage = parseInt(searchParams.get('page') ?? "1") - 1;
  let guardingActivitiesData: IGuardingActivityDetails[] | undefined = []
  let pagination: IPagination | undefined

  const [guardingActivitiesResource, guardingActivitiesLoader] = useGuardingActivities()

  useEffect(() => {
    guardingActivitiesLoader.current(currentPage, storeCode)
  }, [guardingActivitiesLoader, storeCode, currentPage])

  if (guardingActivitiesResource.hasLoaded && !guardingActivitiesResource.hasError) {
    const guardingActivitiesResponse = guardingActivitiesResource.data
    pagination = guardingActivitiesResponse?.metadata?.pagination
    guardingActivitiesData = guardingActivitiesResponse?.results
  }

  if (!guardingActivitiesResource.hasLoaded && !guardingActivitiesResource.hasError && !guardingActivitiesResource.noContent)
    return (
      <Container size="xs">
        <Card id="s-loadingElement" className="ln-u-text-align-center">
          <Loading size="large" />
        </Card>
      </Container>
    )

  if (
    guardingActivitiesResource.hasError ||
    !guardingActivitiesData ||
    guardingActivitiesData?.length <= 0 ||
    guardingActivitiesResource.noContent
  )
    return (
      <Container size="xs">
        <ErrorMessage errorMessage="No Reported Activities Were Found" />
      </Container>
    )

  return (
    <>
      <Container className="s-reported-accidents-list" size="xs">
        <GridWrapper
          id="s-reported-accident-cards"
          matrix
          gutterSize="sm"
          className="ln-o-grid--gutter-zero@max-mobile"
        >
          {guardingActivitiesData.map((guardingActivity: IGuardingActivityDetails, index: Key) => (
            <GuardingActivityCard key={index} guardingActivity={guardingActivity} />
          ))}
        </GridWrapper>
      </Container>

      {pagination && guardingActivitiesData && (
        <Pagination
          id="s-pagination-bar"
          className="ln-u-text-align-center ln-u-margin-ends*3"
          showFirstAndLast
          current={pagination.currentPage}
          total={pagination.totalPages}
          onChange={(page: number, e: any) => {
            e.preventDefault()
            navigate(`?page=${page}`);
          }}
        />
      )}
    </>
  )
}

export default GuardingDailyActivities